import React from 'react';
import './ErrorPopUp.css'

function ErrorPopUp() {
    return (
        <div className="ErrorPopUp complete__fadein">
            <p>Oops this item is already in your cart!</p>
        </div>
    )
}

export default ErrorPopUp
